/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID", // Application (client) ID from Azure portal
        authority:
            process.env.REACT_APP_AZURE_AUTHORITY ||
            "https://login.microsoftonline.com/YOUR_TENANT_ID", // Directory (tenant) ID
        redirectUri:
            process.env.REACT_APP_REDIRECT_URI || window.location.origin, // Must be registered as a redirect URI in Azure portal
        postLogoutRedirectUri:
            process.env.REACT_APP_REDIRECT_URI || window.location.origin, // Redirect after logout
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

const clientId = process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID";
const apiScope = process.env.REACT_APP_API_SCOPE || `api://${clientId}/access_as_user`;

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [
        apiScope,
        "openid",
        "profile",
        "email",
    ],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API.
 * For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
